import {IconButton} from '@dropbox/dig-components/buttons';
import {Menu} from '@dropbox/dig-components/menu';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronDownLine} from '@dropbox/dig-icons/assets';
import {t} from 'i18next';
import {type MouseEvent} from 'react';

import {QuarterEarnings, quarterId} from './earningsData';

/** Keep the menu above dashboard chrome (sticky search is z-index 4). */
const MENU_Z_INDEX = 20;

/** Header dropdown for switching between this fiscal year's published quarters. */
export const EarningsQuarterMenu = ({
  quarters,
  selectedId,
  onSelect,
}: {
  quarters: QuarterEarnings[];
  selectedId: string;
  onSelect: (id: string) => void;
}) => (
  <Menu.Wrapper shouldPropagateClickOutsideMouseEvents>
    {({getContentProps, getTriggerProps}) => (
      <>
        <IconButton
          {...getTriggerProps()}
          variant="borderless"
          size="small"
          aria-label={t('dashboard_earnings_select_quarter').toString()}
          onMouseDown={(e: MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
        >
          <UIIcon src={ChevronDownLine} className={atoms({color: 'Text Subtle'})} />
        </IconButton>
        <Menu.Content
          {...getContentProps()}
          minWidth="180px"
          placement="bottom-start"
          positioningStrategy="fixed"
          style={{zIndex: MENU_Z_INDEX}}
        >
          <Menu.Segment>
            {quarters.map((q) => {
              const id = quarterId(q);
              return (
                <Menu.SelectItem key={id} selected={id === selectedId} onClick={() => onSelect(id)}>
                  {q.quarterLabel}
                </Menu.SelectItem>
              );
            })}
          </Menu.Segment>
        </Menu.Content>
      </>
    )}
  </Menu.Wrapper>
);
